module.exports = __webpack_public_path__ + "media/images/icons/location-10ff509c222216c65a2270b7b89c7082.svg";